module.exports = require("@mui/icons-material/ArrowUpward");